import Handlebars from '@sparta.global.vendors/handlebars';

/**
 * Constant for storing message strings.
 */
const STRINGS = {
  CAROUSEL_NO_JCR: 'No JCR objects provided to helper.'
};

/**
 * 
 * @param {*} context 
 * @param {*} options 
 * @returns 
 */
function setBlockContent(context, options) {
  if (options && options.isBlockHelperOptions) {
    const blockHelperTemplate = Handlebars.compile(`${options.helperBlockContent}`);
    return blockHelperTemplate(context);
  }
  if (options && Object.prototype.hasOwnProperty.call(options, 'fn')) {
    return options.fn(context);
  }
}

/**
 * @method helpers.carouselGroupHelper
 * @param {object} context JSON object used to build the carousel group.
 * @param {object} options HTML that is between the item brackets.
 * @returns {Node} `Handlebars.SafeString`.
 */

function carouselGroupHelper(context, options) {
  if (!context) {
    throw new Error(STRINGS.CAROUSEL_NO_JCR);
  }
  if (context) {
    let content = setBlockContent(context, options);
    let classList = context.classList ? context.classList : '';
    // check controlsPosition value from jcr to apply styles
    if (context.options !== undefined && context.options.controlsPosition === 'outside') {
      classList += ' carousel__nav--outside';
    }
    const randomized = `${Math.floor(Math.random() * 90000) + 10000}`;
    const groupID = context.id ? `id="${context.id}"` : `id="carouselGroup${randomized}"`;
    const output = `
      <section 
        ${groupID}
        class="spa-carousel ${classList}"
        aria-roledescription="carousel"
      >
        <div class="carousel__slide-wrapper">
          <div aria-live="polite" class="ada-hidden spa-aria-live"></div>
          <div class="carousel__slides">
              ${content}
          </div>
        </div>
      </section>
    `;

    // Return HTML to page.
    return new Handlebars.SafeString(`${output.replace(/[\t\n\r]/gm, '')}`);
  } else {
    return '';
  }
}
/**
 * @method helpers.carouselSlideHelper
 * @param {object} context JSON object used to build the carousel group.
 * @param {object} options HTML that is between the item brackets.
 * @returns {Node} `Handlebars.SafeString`.
 */
function carouselSlideHelper(context, options) {
  if (!context) {
    throw new Error(STRINGS.CAROUSEL_NO_JCR);
  }
  if (context) {
    let content = '';
    if (typeof context.content !== 'undefined' && typeof context.content === 'string') {
      content = context.content;
    } else {
      content = setBlockContent(context, options);
    }
    const slideADADescription = context.adaSlideDescription || '';
    const output = `
      <div 
        class="carousel__item"
        aria-roledescription="Slide"
        ${context.options ? `data-options="${Handlebars.Utils.escapeExpression(JSON.stringify(context.options))}"` : ''}
        data-ada="${slideADADescription}"
      >
        <div class="carousel__content">
          ${content}
        </div>
      </div>
    `;

    // Return HTML to page.
    return new Handlebars.SafeString(`${output.replace(/[\t\n\r]/gm, '')}`);
  } else {
    return '';
  }
}

export { carouselGroupHelper, carouselSlideHelper };
